<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="6" class="pe-1">
            <v-autocomplete
                :prefix="`#${index + 1}`"
                label="Component"
                :value="component_id"
                :rules="[isRequired]"
                @input="$emit('update:component_id', $event)"
                outlined
                :items="landedCostComponents"
                item-text="name"
                item-value="id"
                @update:search-input="searchLandedCostComponents"
                dense
                hide-details="auto"
            ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="pe-1">
            <div class="d-flex align-center">
                <v-text-field
                    :rules="[isRequired, isNumeric]"
                    label="Cost"
                    :value="cost"
                    @input="$emit('update:cost', $event)"
                    outlined
                    dense
                    hide-details="auto"
                >
                </v-text-field>
                <v-btn icon @click="$emit('remove')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import landedCostComponent from '../../services/purchase/landedCostComponent';
import { isRequired, isNumeric } from './../../utils/validations';

export default {
    props: {
        index: [String, Number],
        component_id: [String, Number],
        cost: [String, Number],
        landedCostComponents: Array
    },
    data() {
        return {
            landedCostComponentsLoading: false
        }
    },
    methods: {
        isRequired,
        isNumeric,
        searchLandedCostComponents(query) {
            this.landedCostComponentsLoading = true;
            landedCostComponent.search(query).then(res => {
                this.$emit("update:landed-cost-components", [...this.landedCostComponents, ...res.data]);
            }).finally(() => {
                this.landedCostComponentsLoading = false;
            })
        }
    }
}
</script>

<style>

</style>